'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthBlockSelectList = require('@narvar/nth-block-select-list');
var index = require('../TextLink/index.js');
var index$1 = require('../Language/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const GAP = 8;
const MAX_ROWS = 2;
const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-178adqf-0"
})(["width:100%;display:flex;gap:", "rem;flex-wrap:wrap;"], GAP / 16);
const Label = styled__default["default"].label.withConfig({
  componentId: "sc-178adqf-1"
})(["font-weight:700;"]);
const SwatchesList = _ref => {
  let {
    type,
    label,
    value,
    options = [],
    onChange
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const [expanded, setExpanded] = React.useState(false);
  const [containerHeight, setContainerHeight] = React.useState(0);
  const [hasMoreToggle, setHasMoreToggle] = React.useState(false);
  const selectedOption = React.useMemo(() => options.find(o => o.value === value), [options, value]);
  const selectListOptions = options.map(o => {
    var _o$label;
    return {
      value: o.value,
      ariaLabel: ((_o$label = o.label) === null || _o$label === void 0 ? void 0 : _o$label.toString()) ?? '',
      label: type === 'image' ? o.imageUrl ?? '' : o.label,
      isDisabled: o.disabled ?? false,
      isGrayedOut: o.grayedOut ?? false
    };
  });
  const listRef = React.useRef(null);
  React.useEffect(() => {
    const handleResize = () => {
      if (!listRef.current) return;
      const selectListContainer = listRef.current.firstChild;
      const firstItem = selectListContainer.firstChild;
      const calcContainerHeight = firstItem.offsetHeight * MAX_ROWS + GAP * (MAX_ROWS - 1);
      if (selectListContainer.offsetHeight / calcContainerHeight > 1) {
        setHasMoreToggle(true);
      }
      setContainerHeight(calcContainerHeight > selectListContainer.offsetHeight ? selectListContainer.offsetHeight : calcContainerHeight);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [listRef]);
  const handleChange = newValue => {
    if (!onChange) return;
    if (Array.isArray(newValue)) return;
    onChange(newValue === value || !newValue ? '' : newValue);
  };
  const handleToggleSeeMore = () => {
    setExpanded(d => !d);
  };
  const wrapperStyles = type === 'image' ? {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '0.5rem'
  } : {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem'
  };
  return /*#__PURE__*/React__default["default"].createElement(Wrapper, null, label && /*#__PURE__*/React__default["default"].createElement(Wrapper, null, /*#__PURE__*/React__default["default"].createElement(Label, null, label), selectedOption && selectedOption.label), /*#__PURE__*/React__default["default"].createElement("div", {
    ref: listRef,
    style: {
      width: '100%',
      height: expanded ? 'auto' : containerHeight,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBlockSelectList.SelectList, {
    options: selectListOptions,
    component: type === 'image' ? type : 'button',
    wrapperStyles: wrapperStyles,
    value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value,
    isRequired: true,
    limit: 1,
    onChange: handleChange
  })), hasMoreToggle && /*#__PURE__*/React__default["default"].createElement(Wrapper, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    onClick: handleToggleSeeMore,
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: expanded ? 'returnsSwatchesListSeeLess' : 'returnsSwatchesListSeeMore'
  }))));
};
var SwatchesList$1 = nthHookTheme.withThemeProvider(SwatchesList, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});

exports["default"] = SwatchesList$1;
